import {post, get} from '@/utils/request'

// 获取号卡类型
export function getCardType(data) {
    return post({
        data,
        url: 'resource/sys-pa-code/getCardType'
    })
}
// 获取运营商类型
export function getOperatorType(data) {
    return post({
        data,
        url: 'resource/sys-pa-code/getOperatorType'
    })
}
// 获取号卡状态
export function getCardStatus(data) {
    return post({
        data,
        url: 'resource/sys-pa-code/getCardStatus'
    })
}
// 获取号卡列表
export function cardList(data) {
    return post({
        data,
        url: 'resource/res-card-iccid/cardList'
    })
}

// 删除号卡
export function deleteCard(data) {
    return post({
        data,
        url: 'resource/res-card-iccid/deleteCard'
    })
}

// 号卡导出
export function cardListExport(data) {
    return post({
        data,
        url: 'resource/res-card-iccid/cardListExport'
    })
}


// 号卡导入
export function upload(data) {
    return post({
        data,
        url: 'resource/res-card-iccid/upload'
    })
}

// 下载号卡导入模板
export function download(data) {
    return post({
        data,
        url: 'resource/res-card-iccid/download',
        responseType: 'blob'
    })
}
  